module.exports = "<h1 id=the-most-bedazzling-pieces-br-of-light-art-you-may-ever-see>The most bedazzling pieces<br>of light art you may ever see</h1> <h2 id=new-york-times>New York Times</h2> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/markdown/carousel/carousel_quote_4.md
// module id = 111
// module chunks = 0